import { ReactNode } from 'react';
import styles from './FilterSet.module.css';

export function FilterSet({ children }: { children: ReactNode }) {
  return <div className={styles.filterSet}>{children}</div>;
}
